<template>
  <button
    type="button"
    class="badge flex shrink-0 flex-col gap-0.5 rounded-xl px-2 py-1 pr-2.5 text-left text-[11px] font-medium leading-[100%] text-white"
  >
    <i18next :translation="t('cashback.title')">
      <template #percent>
        <span class="flex font-bold">
          <span class="flex shrink-0 items-center justify-center">
            <img
              class="h-4.5 w-4"
              src="../assets/freedom-logo-rotated.svg"
              alt=""
              width="16"
              height="18"
            />
          </span>
          <span class="text-base leading-[100%]">
            {{ freedomCashback.cashbackPercent.value }}%
          </span>
        </span>
      </template>
    </i18next>
  </button>
</template>

<script setup lang="ts">
  import { useCashbackLocales } from '../locales';
  import { useFreedomCashback } from '../model/use-freedom-cashback';

  const { t } = useCashbackLocales();
  const freedomCashback = useFreedomCashback();
</script>

<style scoped>
  .badge {
    background: linear-gradient(262.23deg, #01d58a -1.12%, #006fc2 101.31%);
  }
</style>
